import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { GetTopicResponse } from '../../types';

@customElement('insight-card')
export class InsightCard extends LitElement {
    private readonly amplitude_callsite: string = 'Insight Card';

    @property({ type: String })
    statNumber: String = 'None';

    @property({ type: Object })
    statTopic?: GetTopicResponse;

    @property({ type: String })
    actionString?: String;

    @property({ type: String })
    statName: String = 'NA';

    @property({ type: String})
    changeName?: String;

    @property({ type: Boolean})
    blocked?: boolean;

    @property({ type: Number})
    changeNumber?: Number;

    @property({ type: String})
    moreInfoText?: String;

    private onClick() {
        this.dispatchEvent(new CustomEvent('click'));
    }

    private onActionClick() {
        this.dispatchEvent(new CustomEvent('action-click'));
    }

    protected render() {
        return html`
            <div class="insight-card__wrapper">
                <div class="insight-card__stat-name">
                    <span>${this.statName ?? ''}</span>
                    <span @click="${this.onActionClick}" style="text-decoration:underline;cursor:pointer"> ${this.actionString}</span>
                </div>
                <div class="insight-card__stat-number">
                    <span>${this.blocked === true ?
                            'N/A' : this.statTopic?.name ?? this.statNumber}</span>
                    ${this.blocked === true ? html`
                        <div class="insight-card__blocked"></div>
                    ` : ``}
                </div>
                ${this.moreInfoText ? html`
                    <div class="insight-card__more-info" @click="${this.onClick}">
                        <span style="text-decoration:underline">${this.moreInfoText}</span>
                    </div>
                ` : ``}
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`

            .insight-card__wrapper {
                width: 100%;
                border-radius: 0.75rem;
                background: #1d485f;
                border-radius: 12px;
                padding: 1rem;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                box-sizing: border-box;
                color: var(--main-secondary-color);
                overflow: hidden;
            }

            .insight-card__stat-number {
                color: white;
                font-size: 20px;
                font-weight: 500;
                line-height: 130%;
                position: relative;
                width: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .insight-card__blocked {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: rgba(255, 255, 255, 0.75);
                -webkit-backdrop-filter: blur(9px); /* fixes blur for Safari*/
                backdrop-filter: blur(9px);
            }

            .insight-card__stat-name {
                color: var(--theme-input-border-color);
                font-size: 12px;
                line-height: 150%;
            }

            .insight-card__more-info {
                color: var(--main-invalid-color);
                font-size: 12px;
                font-style: italic;
                line-height: 100%;
                margin-top: 1rem;
                cursor: pointer;
            }

            @media (max-width: 500px) {

                .insight-card__stat-number {
                    font-size: 16px;
                }
            }
        `;
    }
}